/**
 * 機嫌リスト.
 */
export const MOOD_CATEGORY_TYPE = [
  '良好',
  'ふつう',
  '不機嫌',
] as const;

/**
 * 機嫌の型
 */
export type MoodCategoryType = typeof MOOD_CATEGORY_TYPE[number];
